function normalizeBlocks(zen) {
  const raw = zen.blocks || zen.content?.blocks || zen.content;

  // Wenn bereits ein Array von Editor.js-Blöcken
  if (Array.isArray(raw)) {
    return raw.map((block) => {
      if (block?.type === "model") block.type = "model3d"; // Legacy-Kompatibilität
      return block;
    });
  }

  // Wenn content ein einfacher Textstring ist
  if (typeof raw === "string") {
    return [
      {
        type: "paragraph",
        data: {
          text: raw.replace(/\n/g, "<br>"), // \n → <br> für Zeilenumbrüche
        },
      },
    ];
  }

  return []; // Fallback
}

function getApiBase() {
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return ""; // nutzt CRA-Proxy -> https://www.denisbitter.de/stage01/api
  }
  return "https://www.denisbitter.de/stage01/api";
}

async function fetchJsonWithTimeout(url, timeoutMs = 12000) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(url, { signal: controller.signal });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    return await response.json();
  } finally {
    clearTimeout(timeoutId);
  }
}

export async function loadZens() {
  const all = [];

  try {
    const apiBase = getApiBase();
    // 📥 1. Liste der Artikel-Dateien vom Server
    const filenames = await fetchJsonWithTimeout(`${apiBase}/zens.php`);

    // 🔁 2. Lade jede Datei einzeln
    for (const file of filenames) {
      try {
        const json = await fetchJsonWithTimeout(`${apiBase}/zens.php?slug=${file}`);

        all.push({
          ...json,
          blocks: normalizeBlocks(json),
          slug: slugify(json.title || "unbenannt"),
        });
      } catch (err) {
        console.warn(`⚠️ Artikel ${file} konnte nicht geladen werden:`, err);
      }
    }
  } catch (e) {
    console.error("❌ Fehler beim Laden der Zenliste:", e);
  }

  return all;
}

function slugify(title = "") {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}
